import { render, staticRenderFns } from "./modalEditarImagenCedis.vue?vue&type=template&id=788fcd57&"
import script from "./modalEditarImagenCedis.vue?vue&type=script&lang=js&"
export * from "./modalEditarImagenCedis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports